export const SELECTORS = {
  CONTAINER: 'js-tabs-container',
  TAB: 'js-tabs-item',
  TAB_CONTENT: 'js-tabs-content'
};
